module.exports = __webpack_public_path__ + "static/media/logo-full.798f478c.png";